import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Tab } from "@pentabd/ui";
import {
  Category,
  Brand,
  // Condition,
  Group,
  Name,
  SettingsHeader,
  Unit,
} from "./components";

const InventorySettings = () => {
  const { t } = useTranslation();
  const [currentTab, setCurrentTab] = useState(0);
  const handleActiveTab = (tabIndex: number) => setCurrentTab(tabIndex);
  const scrollToTopRef = useRef<any>(null);

  const handleScrollToTop = () => {
    if (scrollToTopRef.current) {
      scrollToTopRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const tabData = [
    {
      label: t("INVENTORY_SETTINGS.TABS.CATEGORY"),
      component: <Category handleScrollToTop={handleScrollToTop} />,
    },
    {
      label: t("INVENTORY_SETTINGS.TABS.GROUP"),
      component: <Group handleScrollToTop={handleScrollToTop} />,
    },
    {
      label: t("INVENTORY_SETTINGS.TABS.BRAND"),
      component: <Brand handleScrollToTop={handleScrollToTop} />,
    },
    {
      label: t("INVENTORY_SETTINGS.TABS.NAME"),
      component: <Name handleScrollToTop={handleScrollToTop} />,
    },
    {
      label: t("INVENTORY_SETTINGS.TABS.UNIT"),
      component: <Unit handleScrollToTop={handleScrollToTop} />,
    },
    // {
    //   label: t("INVENTORY_SETTINGS.TABS.CONDITION"),
    //   component: <Condition />,
    // },
  ];

  return (
    <div className="container p-10">
      <SettingsHeader />
      <div className="pt-10">
        <Tab active={currentTab} setActiveTab={handleActiveTab}>
          <Tab.Heads>
            {tabData.map(({ label }, i) => (
              <Tab.Item key={i} index={i} label={label} />
            ))}
          </Tab.Heads>
          <Tab.ContentWrapper>
            {tabData.map(({ component }, i) => (
              <Tab.Content key={i} index={i}>
                {component}
              </Tab.Content>
            ))}
          </Tab.ContentWrapper>
        </Tab>
      </div>
    </div>
  );
};

export default InventorySettings;
